import { create } from 'zustand';
import { combine } from 'zustand/middleware';

export const useInputStore = create(
  combine({ showPassword: false }, (set) => ({
    setShowPassword: (showPassword: boolean) => set({ showPassword }),
    toggleShowPassword: () =>
      set((state) => ({ showPassword: !state.showPassword })),
  })),
);
